import React from 'react';
import { Sidebar } from './Sidebar';
import { TrialBanner } from './TrialBanner';

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-surface-bg">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <TrialBanner />
        {children}
      </main>
    </div>
  );
}
